export default {
  title: {
    id: 'bo_sellers-orders-drawers-imei-add_title',
    defaultMessage: 'Add IMEI',
  },
  prompt: {
    id: 'bo_sellers-orders-drawers-imei-add-info_message',
    defaultMessage: 'Add IMEI for orderline {orderLineId}',
  },
  imei: {
    id: 'bo_sellers-orders-drawers-imei-add-imei',
    defaultMessage: 'IMEI',
  },
  required: {
    id: 'bo_sellers-orders-drawers-imei-add-error-required',
    defaultMessage: 'This field is required',
  },
  confirm: {
    id: 'bo_sellers-orders-drawers-imei-add_submit',
    defaultMessage: 'Add IMEI',
  },
  cancel: {
    id: 'bo_sellers-orders-drawers-imei-add_cancel',
    defaultMessage: 'Cancel',
  },
  successMessage: {
    id: 'bo_sellers-orders-drawers-imei-add_success-message',
    defaultMessage: 'IMEI has been successfuly saved.',
  },
} as const
